import { pxToRem, responsiveFontSizes } from '../utils/getFontValue';
import { poppins } from './utils';

// ----------------------------------------------------------------------

const FONT_PRIMARY = poppins.style.fontFamily; // Google Font
// const FONT_SECONDARY = 'CircularStd, sans-serif'; // Local Font

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    letterSpacing: 2,
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontWeight: 700,
    lineHeight: 64 / 48,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 28, md: 30, lg: 32 }),
  },
  h4: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 22, md: 23, lg: 24 }),
  },
  h5: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 16, md: 18, lg: 20 }),
  },
  h6: {
    fontWeight: 600,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 16, md: 17, lg: 18 }),
  },
  titleHeader: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 16, md: 17, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.6,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ sm: 14, md: 16, lg: 16 }),
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  subtitle3: {
    fontWeight: 600,
    lineHeight: 14 / 12,
    fontSize: pxToRem(12),
  },
  body1: {
    fontWeight: 400,
    lineHeight: 1.6,
    fontSize: pxToRem(16),
  },
  body2: {
    fontWeight: 400,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ sm: 12, md: 14, lg: 14 }),
  },
  body3: {
    fontWeight: 400,
    lineHeight: 20 / 12,
    fontSize: pxToRem(12),
  },
  body4: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(16),
  },
  body5: {
    fontWeight: 500,
    lineHeight: '18px',
    fontSize: pxToRem(12),
  },
  body6: {
    fontWeight: 400,
    lineHeight: '18px',
    fontSize: pxToRem(12),
  },
  body7: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(18),
  },
  body8: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 14, md: 18, lg: 18 }),
  },
  caption: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(12),
  },
  caption2: {
    fontWeight: 400,
    lineHeight: 1.6,
    fontSize: pxToRem(12),
  },
  caption3: {
    fontWeight: 400,
    fontSize: pxToRem(10),
  },
  caption4: {
    fontWeight: 400,
    lineHeight: 1.1,
    fontSize: pxToRem(12),
  },
  caption5: {
    fontWeight: 500,
    lineHeight: 1.1,
    fontSize: pxToRem(14),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.6,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 500,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'capitalize',
  },
  title: {
    fontWeight: 600,
    lineHeight: 1.6,
    ...responsiveFontSizes({ sm: 16, md: 18, lg: 18 }),
  },
  leyend1: {
    fontWeight: 400,
    lineHeight: 1.6,
    ...responsiveFontSizes({ sm: 10, md: 12, lg: 14 }),
  },
  leyend2: {
    fontWeight: 500,
    lineHeight: 1.6,
    ...responsiveFontSizes({ sm: 10, md: 10, lg: 12 }),
  },
  titlePayment: {
    fontWeight: 500,
    lineHeight: 1.1,
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ sm: 12, md: 14, lg: 14 }),
  },
  subtitlePayment: {
    fontWeight: 400,
    lineHeight: 1.1,
    fontSize: pxToRem(12),
    ...responsiveFontSizes({ sm: 10, md: 12, lg: 12 }),
  },
  bodyCard: {
    fontWeight: 400,
    fontSize: pxToRem(10),
  },
};

export default typography;
